import React from 'react';
import { Box, Stack, Skeleton, useTheme } from '@mui/material';
import _ from 'lodash';

const TABLE_ROWS = 3;

const TransactionsSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(3, 138, 183, 0.05)',
        borderRadius: 5,
        p: 5,
      }}>
      <Stack direction='row' justifyContent='space-between' alignItems='flex-start' mb={4}>
        <Box>
          <Skeleton
            variant='rectangular'
            animation='wave'
            sx={{
              borderRadius: 2,
              backgroundColor: theme.palette.primary.disabled,
              opacity: 0.5,
              width: '120px',
              height: '32px',
            }}
          />
        </Box>
      </Stack>

      <Box mb={2}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' mb={3}>
          <Skeleton
            variant='rectangular'
            animation='wave'
            sx={{
              borderRadius: 2,
              backgroundColor: theme.palette.primary.disabled,
              opacity: 0.5,
              width: '150px',
              height: '24px',
            }}
          />
          <Skeleton
            variant='rectangular'
            animation='wave'
            sx={{
              borderRadius: 2,
              backgroundColor: theme.palette.primary.disabled,
              opacity: 0.5,
              width: '100px',
              height: '36px',
            }}
          />
        </Stack>

        <Skeleton
          variant='rectangular'
          animation='wave'
          sx={{
            borderRadius: 2,
            backgroundColor: theme.palette.primary.disabled,
            opacity: 0.5,
            width: '100%',
            height: '40px',
          }}
        />
      </Box>

      <Stack spacing={0}>
        {_.times(TABLE_ROWS, index => (
          <Box
            key={index}
            sx={{
              py: 1,
            }}>
            <Skeleton
              variant='rectangular'
              animation='wave'
              sx={{
                borderRadius: 2,
                backgroundColor: theme.palette.primary.disabled,
                opacity: 0.5,
                width: '100%',
                height: '25px',
              }}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default TransactionsSkeleton;
